import React from 'react';

const ParkingMarkers = () => (
	<g id="parking" transform="translate(1098.000000, 904.000000)">
		<g id="ic-parking" transform="translate(0.000000, 167.000000)">
			<rect id="Rectangle-Copy-11" fill="#007AFF" fillRule="evenodd" x="8" y="8" width="16" height="16" rx="4"/>
			<g id="parking-number" transform="translate(20.000000, 18.000000)" fill="#FFFFFF"
				 fontFamily="OpenSans-ExtraBold, Open Sans" fontSize="7" fontWeight="600">
				<text id="1">
					<tspan x="-1.80078125" y="2.95">1</tspan>
				</text>
			</g>
			<path
				d="M15.8769231,15.3076923 L14.1538462,15.3076923 L14.1538462,13.1538462 L15.8769231,13.1538462 C16.4692308,13.1538462 16.9538462,13.6384615 16.9538462,14.2307692 C16.9538462,14.8230769 16.4692308,15.3076923 15.8769231,15.3076923 M15.7692308,11 L12,11 L12,20.6923077 L14.1538462,20.6923077 L14.1538462,17.4615385 L15.7692308,17.4615385 C17.551,17.4615385 19,16.0130769 19,14.2307692 C19,12.4484615 17.551,11 15.7692308,11"
				id="Fill-1" fill="#FFFFFF"
				fillRule="evenodd"/>
		</g>
		{/*<g id="ic-parking" transform="translate(346.000000, 97.000000)">*/}
		{/*	<rect id="Rectangle-Copy-11" fill="#007AFF" x="8" y="8" width="16" height="16" rx="4"/>*/}
		{/*	<path*/}
		{/*		d="M15.8769231,15.3076923 L14.1538462,15.3076923 L14.1538462,13.1538462 L15.8769231,13.1538462 C16.4692308,13.1538462 16.9538462,13.6384615 16.9538462,14.2307692 C16.9538462,14.8230769 16.4692308,15.3076923 15.8769231,15.3076923 M15.7692308,11 L12,11 L12,20.6923077 L14.1538462,20.6923077 L14.1538462,17.4615385 L15.7692308,17.4615385 C17.551,17.4615385 19,16.0130769 19,14.2307692 C19,12.4484615 17.551,11 15.7692308,11"*/}
		{/*		id="Fill-1" fill="#FFFFFF"/>*/}
		{/*</g>*/}
		<g id="ic-parking" transform="translate(415.000000, 26.000000)">
			<rect id="Rectangle-Copy-11" fill="#007AFF" fillRule="evenodd" x="8" y="8.5" width="16" height="17" rx="4"/>
			<g id="parking-number" transform="translate(20.000000, 19.153125)" fill="#FFFFFF"
				 fontFamily="OpenSans-ExtraBold, Open Sans" fontSize="7" fontWeight="600">
				<text id="1">
					<tspan x="-1.80078125" y="2.95">2</tspan>
				</text>
			</g>
			<path
				d="M15.8769231,16.2644231 L14.1538462,16.2644231 L14.1538462,13.9759615 L15.8769231,13.9759615 C16.4692308,13.9759615 16.9538462,14.4908654 16.9538462,15.1201923 C16.9538462,15.7495192 16.4692308,16.2644231 15.8769231,16.2644231 M15.7692308,11.6875 L12,11.6875 L12,21.9855769 L14.1538462,21.9855769 L14.1538462,18.5528846 L15.7692308,18.5528846 C17.551,18.5528846 19,17.0138942 19,15.1201923 C19,13.2264904 17.551,11.6875 15.7692308,11.6875"
				id="Fill-1" fill="#FFFFFF" fillRule="evenodd"/>
		</g>
		<g id="ic-parking" transform="translate(528.000000, 0.000000)">
			<rect id="Rectangle-Copy-11" fill="#007AFF" x="8" y="8" width="16" height="16" rx="4"/>
			<path
				d="M15.8769231,15.3076923 L14.1538462,15.3076923 L14.1538462,13.1538462 L15.8769231,13.1538462 C16.4692308,13.1538462 16.9538462,13.6384615 16.9538462,14.2307692 C16.9538462,14.8230769 16.4692308,15.3076923 15.8769231,15.3076923 M15.7692308,11 L12,11 L12,20.6923077 L14.1538462,20.6923077 L14.1538462,17.4615385 L15.7692308,17.4615385 C17.551,17.4615385 19,16.0130769 19,14.2307692 C19,12.4484615 17.551,11 15.7692308,11"
				id="Fill-1" fill="#FFFFFF"/>
		</g>
		<g id="ic-parking" transform="translate(876.000000, 5.000000)">
			<rect id="Rectangle-Copy-11" fill="#007AFF" x="8" y="8" width="16" height="16" rx="4"/>
			<path
				d="M15.8769231,15.3076923 L14.1538462,15.3076923 L14.1538462,13.1538462 L15.8769231,13.1538462 C16.4692308,13.1538462 16.9538462,13.6384615 16.9538462,14.2307692 C16.9538462,14.8230769 16.4692308,15.3076923 15.8769231,15.3076923 M15.7692308,11 L12,11 L12,20.6923077 L14.1538462,20.6923077 L14.1538462,17.4615385 L15.7692308,17.4615385 C17.551,17.4615385 19,16.0130769 19,14.2307692 C19,12.4484615 17.551,11 15.7692308,11"
				id="Fill-1" fill="#FFFFFF"/>
		</g>
	</g>
);


export default ParkingMarkers;
